import React, { useContext, useEffect, useState, useCallback } from 'react';
import DepositCss from '../css/DepositCss';
import { useNavigate } from 'react-router-dom';
import { Context } from '../Context/Context';
import { Flip, toast } from 'react-toastify';
import { GetAlClientsApi } from '../Api/GetAllClients';
import { LainDainApi } from '../Api/LainDainSet';
import { LainDainGetApi } from '../Api/LainDainGet';
import { Helmet } from 'react-helmet';
export default function EditClient() {
  const navigate = useNavigate();
  const { setLoad, setLoadColor } = useContext(Context);

  const [clientList, setClientList] = useState([]);
  const [paymentClient, setPaymentClient] = useState('');
  const [paymentType, setPaymentType] = useState('');
  const [receiveType, setReceiveType] = useState('');
  const [paymentAmount, setPaymentAmount] = useState('');
  const [lainDainRecords, setLainDainRecords] = useState([]);
  const [filterClient, setFilterClient] = useState('');

  const userInfo = JSON.parse(localStorage.getItem('userinfo'));

  const fetchClientList = useCallback(async () => {
    try {
      const res = await GetAlClientsApi({
        username: userInfo?.username,
        user_id: userInfo?.userId,
      });

      if (res.data.status) {
        setClientList(res.data.data);
      } else {
        setClientList([]);
      }
    } catch (error) {
      console.error('Error fetching client list:', error);
    }
  }, [userInfo?.username, userInfo?.userId]);

  const fetchLainDainRecords = useCallback(async (clientName = '') => {
    if (!userInfo?.username || !userInfo?.userId) return;

    const payload = {
      username: userInfo.username,
      user_id: userInfo.userId,
    };

    if (clientName) {
      payload.client_name = clientName;
    }

    try {
      const res = await LainDainGetApi(payload);
      if (res.data.status) {
        setLainDainRecords(res.data.data);
      } else {
        setLainDainRecords([]);
      }
    } catch (error) {
      console.error("Error fetching Lain-Dain records:", error);
      setLainDainRecords([]);
    }
  }, [userInfo?.username, userInfo?.userId]);

  useEffect(() => {
    fetchClientList();
  }, [fetchClientList]);

  useEffect(() => {
    if (filterClient === '') {
      fetchLainDainRecords('');
    } else {
      fetchLainDainRecords(filterClient);
    }
  }, [filterClient, fetchLainDainRecords]);

  const handleSavePayment = async () => {
    if (!paymentClient || !paymentType || !receiveType || !paymentAmount) {
      toast.error("All fields are required", {
        autoClose: 1500,
        theme: "colored",
        transition: Flip,
      });
      return;
    }

    setLoad(true);
    setLoadColor("#434343");

    try {
      const data = {
        username: userInfo?.username,
        user_id: userInfo?.userId,
        client_name: paymentClient,
        amount: Number(paymentAmount),
        type: paymentType,
        receive_type: receiveType,
      };

      const res = await LainDainApi(data);

      if (res.data.status) {
        toast.success("Payment saved successfully", {
          autoClose: 1500,
          theme: "colored",
          transition: Flip,
        });
        setPaymentClient('');
        setPaymentType('');
        setReceiveType('');
        setPaymentAmount('');

        // Refresh filtered records after save
        if (filterClient) {
          fetchLainDainRecords(filterClient);
        } else {
          setLainDainRecords([]);
        }
      } else {
        toast.error(res.data.message, {
          autoClose: 1500,
          theme: "colored",
          transition: Flip,
        });
      }
    } catch (err) {
      console.error(err);
      toast.error("Something went wrong", {
        autoClose: 1500,
        theme: "colored",
        transition: Flip,
      });
    } finally {
      setLoad(false);
    }
  };

  return (
    <DepositCss>
      <Helmet>
        {/* Page Title */}
        <title>Lain Dain | Client Profit & Loss Accounting | Matka Jantri</title>

        {/* SEO Description */}
        <meta
          name="description"
          content="Gambling calculator to maintain hisaab for clients. Track amounts paid in losses or received in profits accurately on the Lain Dain page of MatkaJantri."
        />

        {/* SEO Directives */}
        <meta name="robots" content="index, follow" />

        {/* Canonical URL */}
        <link rel="canonical" href="https://app.matkajantri.com/lain-dain" />

        {/* Favicon and Icons */}
        <link rel="icon" href="/favicon.ico" type="image/x-icon" />
        <link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png" />
        <link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png" />
        <link rel="apple-touch-icon" sizes="180x180" href="/apple-touch-icon.png" />

        {/* Mobile Optimization */}
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />

        {/* Open Graph */}
        <meta property="og:title" content="Lain Dain | Client Profit & Loss Accounting | MatkaJantri" />
        <meta
          property="og:description"
          content="Gambling calculator to maintain hisaab for clients. Track amounts paid in losses or received in profits accurately on the Lain Dain page of MatkaJantri."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://app.matkajantri.com" />
        <meta property="og:image" content="https://app.matkajantri.com/Logo.png" />
        <meta name="google-site-verification" content="d6d81656210c6db7" />
      </Helmet>

      <div className="w-100 fullpage">
        <div className="w-3">
          <div className="back-top">
            <i className="fa-solid fa-chevron-left" onClick={() => navigate("/game")}></i>
          </div>
          <div className="w-100 text-center d-flex">
            <button className="addFunds">
              <i className="fa-solid fa-user-pen"></i> Lain-Dain
            </button>
          </div>

          {/* --- Payment Form --- */}
          <div className="w-100 px-3 mt-4">
            <div className="mb-3 w-100">
              <label className="form-label">Select Client <span style={{ color: 'red' }}>*</span></label>
              <select className="form-control" value={paymentClient} onChange={(e) => setPaymentClient(e.target.value)}>
                <option value="">-- Select Client --</option>
                {clientList.map((client, idx) => (
                  <option key={idx} value={client.client_name}>{client.client_name}</option>
                ))}
              </select>
            </div>

            <div className="mb-3 w-100">
              <label className="form-label">Payment Type <span style={{ color: 'red' }}>*</span></label>
              <select className="form-control" value={paymentType} onChange={(e) => setPaymentType(e.target.value)}>
                <option value="">-- Select Type --</option>
                <option value="pay">Pay</option>
                <option value="receive">Receive</option>
              </select>
            </div>

            <div className="mb-3 w-100">
              <label className="form-label">Receive Type <span style={{ color: 'red' }}>*</span></label>
              <select className="form-control" value={receiveType} onChange={(e) => setReceiveType(e.target.value)}>
                <option value="">-- Select Mode --</option>
                <option value="cash">Cash</option>
                <option value="online">Online</option>
              </select>
            </div>

            <div className="mb-3 w-100">
              <label className="form-label">Amount <span style={{ color: 'red' }}>*</span></label>
              <input
                type="number"
                className="form-control ps-2"
                value={paymentAmount}
                onChange={(e) => setPaymentAmount(e.target.value)}
              />
            </div>

            <div className="text-center">
              <button className="submit-btn support-btn" onClick={handleSavePayment}>
                Save Payment
              </button>
            </div>

            {/* --- Lain-Dain Records --- */}
            <div className="mt-5">
              <h5>Lain-Dain Records</h5>

              <div className="mt-4">
                <label className="form-label">Filter by Client</label>
                <select
                  className="form-control"
                  value={filterClient}
                  onChange={(e) => setFilterClient(e.target.value)}
                >
                  <option value="">-- Select Client to Filter --</option>
                  {clientList.map((client, idx) => (
                    <option key={idx} value={client.client_name}>
                      {client.client_name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="table-responsive mt-3">
                <table className="table table-bordered table-striped">
                  <thead>
                    <tr>
                      <th>Client Name</th>
                      <th>Type</th>
                      <th>Mode</th>
                      <th>Amount</th>
                      <th>Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    {lainDainRecords.length > 0 ? (
                      lainDainRecords.map(record => (
                        <tr key={record._id}>
                          <td>{record.client_name}</td>
                          <td>{record.type}</td>
                          <td>{record.receive_type}</td>
                          <td>{record.amount}</td>
                          <td>{new Date(record.createdAt).toLocaleString()}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="5" className="text-center">No records found.</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </DepositCss>
  );
}
